var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10937",
    "data-name": "Group 10937",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.115,
    height: 37.276,
    viewBox: "0 0 108.115 37.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 108.115,
    height: 37.276,
    fill: "#e2e4e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10936",
    "data-name": "Group 10936",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30366",
    "data-name": "Path 30366",
    d: "M7.036,24.346l0,.017v.131c0,8.155,5,10.685,9.846,10.685h.3a9.392,9.392,0,0,0,9.392-9.392v-8.33c0,4.847-2.53,9.846-10.685,9.846H10.123a3.09,3.09,0,0,1-3.087-2.956",
    transform: "translate(0.845 2.097)",
    fill: "#e2e4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30367",
    "data-name": "Path 30367",
    d: "M7.878,25.854,7.859,13.541c0-6.005-2.964-7.4-7.859-7.4V27.146a9.393,9.393,0,0,0,9.393,9.392h8.33c-4.848,0-9.846-2.53-9.846-10.685",
    transform: "translate(0 0.737)",
    fill: "#e2e4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30368",
    "data-name": "Path 30368",
    d: "M21.047.295,16.185,5.157A1.006,1.006,0,0,0,16.9,6.874h.821c0,.018.044,19.434.044,19.434a3.09,3.09,0,0,1-2.955,3.086l.016,0h.132c8.155,0,10.685-5,10.685-9.846,0,0,0-12.661.006-12.679h1.1a.955.955,0,0,0,.675-1.631L22.47.295a1,1,0,0,0-1.423,0",
    transform: "translate(1.779 0)",
    fill: "#e2e4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30369",
    "data-name": "Path 30369",
    d: "M45.017,14.337H43.228a2.01,2.01,0,0,0-1.684.911,1.452,1.452,0,0,0-.3.768,2.041,2.041,0,0,0-.031.333v2.683h.006V21.08q0,2.453-2.217,2.453T36.787,21.08V19.032h0V16.349a2.011,2.011,0,0,0-2.011-2.012H32.991v7.451a5.331,5.331,0,0,0,.46,2.3,4.521,4.521,0,0,0,1.261,1.628,5.468,5.468,0,0,0,1.909.978,8.75,8.75,0,0,0,4.764,0,5.458,5.458,0,0,0,1.909-.978,4.522,4.522,0,0,0,1.261-1.628,5.331,5.331,0,0,0,.461-2.3V14.337Z",
    transform: "translate(3.964 1.722)",
    fill: "#e2e4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30370",
    "data-name": "Path 30370",
    d: "M84.085,14.337H82.3a2.009,2.009,0,0,0-1.682.911,1.462,1.462,0,0,0-.3.768,2.042,2.042,0,0,0-.03.333l0,4.731q0,2.453-2.217,2.453T75.855,21.08l0-4.731a2.012,2.012,0,0,0-2.012-2.012H72.059v7.451a5.347,5.347,0,0,0,.46,2.3,4.546,4.546,0,0,0,1.261,1.628,5.474,5.474,0,0,0,1.91.978,8.746,8.746,0,0,0,4.763,0,5.474,5.474,0,0,0,1.91-.978,4.534,4.534,0,0,0,1.261-1.628,5.347,5.347,0,0,0,.46-2.3V14.337Z",
    transform: "translate(8.657 1.722)",
    fill: "#e2e4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30371",
    "data-name": "Path 30371",
    d: "M70.56,17.225a4.558,4.558,0,0,0-1.285-1.592,5.769,5.769,0,0,0-1.91-.967,8.371,8.371,0,0,0-4.658,0,5.919,5.919,0,0,0-1.909.967,4.481,4.481,0,0,0-1.3,1.592A5.3,5.3,0,0,0,59.03,18.7v8.23h1.777a2.012,2.012,0,0,0,2.012-2.012l.008-5.345c0-.925.738-1.742,2.217-1.742a2.13,2.13,0,0,1,1.626.6,2.411,2.411,0,0,1,.566,1.141l.008,5.345a2.012,2.012,0,0,0,2.012,2.012h1.789l-.012-8.23a5.3,5.3,0,0,0-.472-1.471",
    transform: "translate(7.092 1.722)",
    fill: "#e2e4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30372",
    "data-name": "Path 30372",
    d: "M56.988,16.081A6.241,6.241,0,0,0,54.926,14.8a7.128,7.128,0,0,0-2.582-.459,7.576,7.576,0,0,0-3.089.613,5.712,5.712,0,0,0-2.287,1.792,5.555,5.555,0,0,0-.873,1.863,9.908,9.908,0,0,0-.306,2.617L45.8,32.773h1.746a2.012,2.012,0,0,0,2.012-2.012l.007-5.036a4.658,4.658,0,0,0,1.285.837,5.036,5.036,0,0,0,2.181.413,5.774,5.774,0,0,0,2.264-.448,5.5,5.5,0,0,0,1.85-1.274,6.079,6.079,0,0,0,1.25-1.98,6.973,6.973,0,0,0,.46-2.594,6.625,6.625,0,0,0-.5-2.593,5.825,5.825,0,0,0-1.368-2.005m-2.794,6.661a2.558,2.558,0,0,1-1.946.814,2.588,2.588,0,0,1-1.084-.225,2.663,2.663,0,0,1-.86-.613,2.718,2.718,0,0,1-.566-.92,3.188,3.188,0,0,1-.2-1.144,2.778,2.778,0,0,1,.766-2.075,2.658,2.658,0,0,1,1.945-.755,2.616,2.616,0,0,1,1.946.778,2.8,2.8,0,0,1,.766,2.051,2.921,2.921,0,0,1-.766,2.087",
    transform: "translate(5.501 1.722)",
    fill: "#e2e4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30373",
    "data-name": "Path 30373",
    d: "M96.056,16.081A6.236,6.236,0,0,0,94,14.8a7.137,7.137,0,0,0-2.582-.459,7.585,7.585,0,0,0-3.09.613,5.7,5.7,0,0,0-2.286,1.792,5.533,5.533,0,0,0-.873,1.863,9.9,9.9,0,0,0-.307,2.617V32.773H86.6a2.012,2.012,0,0,0,2.013-2.012l.015-5.036a4.65,4.65,0,0,0,1.284.837,5.039,5.039,0,0,0,2.181.413,5.774,5.774,0,0,0,2.264-.448,5.518,5.518,0,0,0,1.852-1.274,6.058,6.058,0,0,0,1.249-1.98,6.951,6.951,0,0,0,.461-2.594,6.625,6.625,0,0,0-.5-2.593,5.81,5.81,0,0,0-1.368-2.005m-2.793,6.661a2.729,2.729,0,0,1-3.03.589,2.668,2.668,0,0,1-.861-.613,2.754,2.754,0,0,1-.566-.92,3.188,3.188,0,0,1-.2-1.144,2.783,2.783,0,0,1,.766-2.075,2.66,2.66,0,0,1,1.945-.755,2.618,2.618,0,0,1,1.947.778,2.8,2.8,0,0,1,.766,2.051,2.925,2.925,0,0,1-.766,2.087",
    transform: "translate(10.195 1.722)",
    fill: "#e2e4e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.3990e62b64589d433ccef0018258494e.svg";
export { ForwardRef as ReactComponent };